import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress,
  LinearProgress,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import SecurityIcon from '@mui/icons-material/Security';
import PaymentIcon from '@mui/icons-material/Payment';
import { useDispatch, useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { instantBookingTokenGeneratorRequest } from '../../redux/Bookings/BookingAction';
import { insertOrderRequest } from '../../redux/Payments/paymentActions';
import { useNavigate } from 'react-router-dom';
import {
  PAYMENT_FAILURE,
  PAYMENT_SUCCESS,
} from '../../component/common/Routes/AppRoutes';
const PaymentProcessingPage = () => {
  const booking = useSelector((state) => state?.booking);
  const dispatch = useDispatch();
  const pnrNumber = booking?.data?.MemberInfo?.pnr_number;
  const paymentUrl = booking?.data?.payment_url;
  const orderData = useSelector((state) => state?.Payment?.order?.data);
  const navigate = useNavigate();
  const orderStatus = orderData?.order_status;
  console.log('booking', booking);
  console.log('pnrNumber', pnrNumber);
  console.log('orderStatus', orderData);
  console.log('paymentUrl', paymentUrl);
  useEffect(() => {
    if (pnrNumber) {
      dispatch(insertOrderRequest(pnrNumber));
    }
  }, []);

  useEffect(() => {
    if (pnrNumber === orderData?.pnr_number)
      setTimeout(() => {
        if (orderStatus === 1) {
          navigate(PAYMENT_SUCCESS, { state: { orderData: orderData } });
        } else {
          navigate(PAYMENT_FAILURE, {
            state: { orderData: orderData, paymentUrl: paymentUrl },
          });
        }
      }, 5000);
  }, [orderStatus, orderData?.pnr_number]);

  return (
    <Container
      maxWidth='sm'
      sx={{ display: 'flex', minHeight: '100vh', alignItems: 'center' }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          <LockIcon color='primary' sx={{ fontSize: 28, mr: 1 }} />
          <Typography variant='h4' component='h1'>
            Payment Processing
          </Typography>
        </Box>
        <CircularProgress size={70} thickness={4} sx={{ mb: 4 }} />
        <Typography
          variant='h5'
          fontWeight='medium'
          color='primary'
          gutterBottom
        >
          Please Wait Patiently
        </Typography>
        <Typography
          variant='body1'
          color='text.secondary'
          sx={{ mb: 4, maxWidth: 400 }}
        >
          Your payment is being processed. This may take a few moments to
          complete.
        </Typography>
        <Box sx={{ width: '100%', mb: 3 }}>
          <LinearProgress sx={{ height: 8, borderRadius: 4 }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
          }}
        >
          <PaymentIcon
            fontSize='small'
            sx={{ mr: 1, color: 'text.secondary' }}
          />
          <Typography
            variant='body2'
            color='text.secondary'
            fontWeight='medium'
          >
            Please do not refresh or close this window
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            pt: 3,
            borderTop: 1,
            borderColor: 'divider',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SecurityIcon
            fontSize='small'
            sx={{ mr: 1, color: 'text.secondary' }}
          />
          <Typography variant='caption' color='text.secondary'>
            Your transaction is secure and encrypted
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};
export default PaymentProcessingPage;

// import React from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   CircularProgress,
//   LinearProgress
// } from "@mui/material";
// import { Lock, Shield } from "lucide-react";
// const PaymentProcessingPage = () => {
//   return (
//     <Container
//       maxWidth="sm"
//       sx={{
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center"
//       }}
//     >
//       <Box
//         sx={{
//           width: "100%",
//           p: 4,
//           textAlign: "center",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           bgcolor: "white",
//           borderRadius: 2,
//           boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
//         }}
//       >
//         <Lock color="#1976D2" size={40} />
//         <Typography
//           variant="h5"
//           component="h1"
//           sx={{ mt: 2, mb: 1, fontWeight: 500 }}
//         >
//           Payment Processing
//         </Typography>
//         <Box sx={{ my: 3, display: "flex", justifyContent: "center" }}>
//           <CircularProgress size={60} />
//         </Box>
//         <Typography
//           variant="h6"
//           sx={{ color: "#1976D2", fontWeight: 500, mb: 1 }}
//         >
//           Please wait patiently
//         </Typography>
//         <Typography variant="body1" sx={{ color: "rgba(0,0,0,0.6)", mb: 3 }}>
//           Your payment is processing
//         </Typography>
//         <Box sx={{ width: "100%", mb: 3 }}>
//           <LinearProgress />
//         </Box>
//         <Typography variant="body2" sx={{ color: "rgba(0,0,0,0.6)", mb: 3 }}>
//           Do not refresh or close this page
//         </Typography>
//         <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
//           <Shield
//             size={16}
//             color="rgba(0,0,0,0.6)"
//             style={{ marginRight: "8px" }}
//           />
//           <Typography variant="caption" sx={{ color: "rgba(0,0,0,0.6)" }}>
//             Secure transaction
//           </Typography>
//         </Box>
//       </Box>
//     </Container>
//   );
// };
// export default PaymentProcessingPage;
